/* BASOAS — Advertorial "7 razones Basoas Bambú"
   Behaviour ported 1:1 from prototype-advertorial/app.js (approved): countdown + sticky CTA.
   Works across the basoas-adv-* sections ([data-bsa-advertorial] roots); no globals besides a
   load guard (each section includes this script); safe with the Theme Editor. */
(() => {
  if (window.__basoasAdvertorial) return;
  window.__basoasAdvertorial = true;

  const ROOT = '[data-bsa-advertorial]';
  const TRIGGER = '[data-bsa-sticky-trigger]';
  const STICKY_KEY = 'basoas-adv-sticky-closed';
  const BODY_CLASS = 'bsa-has-sticky';

  /* ---------------- Countdown ---------------- */
  // Blank deadline = next Sunday 23:59:59 local time (rolls to the following Sunday once passed).
  function nextSundayEnd(from) {
    const d = new Date(from);
    d.setDate(d.getDate() + ((7 - d.getDay()) % 7));
    d.setHours(23, 59, 59, 999);
    return d;
  }

  function getDeadline(el, now) {
    const fixed = el.dataset.deadline ? new Date(el.dataset.deadline) : null;
    return fixed && !isNaN(fixed) ? fixed : nextSundayEnd(now);
  }

  const pad = (n) => String(n).padStart(2, '0');

  function initCountdown(el) {
    const units = {};
    el.querySelectorAll('[data-unit]').forEach((u) => { units[u.dataset.unit] = u; });

    const tick = () => {
      const now = new Date();
      const ms = Math.max(0, getDeadline(el, now) - now);
      const s = Math.floor(ms / 1000);
      units.days.textContent = Math.floor(s / 86400);
      units.hours.textContent = pad(Math.floor((s % 86400) / 3600));
      units.minutes.textContent = pad(Math.floor((s % 3600) / 60));
      units.seconds.textContent = pad(s % 60);
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }

  /* ---------------- Sticky CTA ---------------- */
  function initSticky(bar) {
    let closed = false;
    try { closed = sessionStorage.getItem(STICKY_KEY) === '1'; } catch (e) { /* storage unavailable */ }

    const focusables = bar.querySelectorAll('a, button');

    const setVisible = (visible) => {
      const show = visible && !closed;
      bar.classList.toggle('bsa-is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      focusables.forEach((f) => { f.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle(BODY_CLASS, show);
    };

    // Visible once the headline has scrolled above the viewport. Without a headline
    // (Cabecera section removed), fall back to the first advertorial section.
    const trigger = document.querySelector(TRIGGER) || document.querySelector(ROOT);
    const io = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    io.observe(trigger);

    const onClose = () => {
      closed = true;
      try { sessionStorage.setItem(STICKY_KEY, '1'); } catch (e) { /* storage unavailable */ }
      setVisible(false);
    };
    const closeBtn = bar.querySelector('[data-sticky-close]');
    closeBtn.addEventListener('click', onClose);

    return () => {
      io.disconnect();
      closeBtn.removeEventListener('click', onClose);
      document.body.classList.remove(BODY_CLASS);
    };
  }

  /* ---------------- Lifecycle ---------------- */
  let cleanups = [];

  function destroyAll() {
    cleanups.forEach((fn) => fn());
    cleanups = [];
  }

  // (Re)initialise everything: the sticky depends on the headline in another section,
  // so any section reload in the Theme Editor re-runs the whole setup (no duplicate timers/listeners).
  function initAll() {
    destroyAll();
    document.querySelectorAll(`${ROOT} [data-countdown]`).forEach((el) => cleanups.push(initCountdown(el)));
    document.querySelectorAll(`${ROOT} [data-sticky]`).forEach((bar) => cleanups.push(initSticky(bar)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor: sections are re-rendered on every setting change / reorder.
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', () => setTimeout(initAll, 0));
  document.addEventListener('shopify:section:reorder', initAll);
})();
